var JS_SELECTOR = ".js-fsc";
var JS_CONTAINER_SELECTOR = ".js-fsc-container";
var JS_SBC_SELECTOR = ".js-fsc-sbc";
var JS_INPUT_NAME = "fsc__option";
function showResults(el, count) {
    var _a;
    var combinations = JSON.parse(((_a = document.getElementById('fscCombinations')) === null || _a === void 0 ? void 0 : _a.textContent) || '[]');
    var selectedCombination = JSON.parse(combinations[count]) || [];
    var containerEl = el.querySelector(JS_CONTAINER_SELECTOR);
    if (containerEl) {
        containerEl.innerHTML = '';
    }
    for (var i = 0; i < selectedCombination.length; i++) {
        var sbcs = [];
        for (var j = 0; j < selectedCombination[i].length; j++) {
            var sbcEl = el.querySelector("".concat(JS_SBC_SELECTOR, "[data-id=\"").concat(selectedCombination[i][j], "\"]"));
            if (sbcEl) {
                sbcs.push(sbcEl.cloneNode(true));
            }
        }
        if (sbcs.length > 0) {
            var sbcContainer = document.createElement('div');
            sbcContainer.classList.add('fsc__combination');
            var sbcContainerTitle = document.createElement('h3');
            sbcContainerTitle.classList.add('fsc__combination-title');
            sbcContainerTitle.innerText = "Combination #".concat(i + 1);
            sbcContainer.appendChild(sbcContainerTitle);
            for (var j = 0; j < sbcs.length; j++) {
                sbcContainer.appendChild(sbcs[j]);
            }
            if (containerEl) {
                containerEl.appendChild(sbcContainer);
            }
        }
    }
}
function startSwapsCombinations(el) {
    var inputs = document.querySelectorAll("input[name=\"".concat(JS_INPUT_NAME, "\"]"));
    for (var i = 0; i < inputs.length; i++) {
        inputs[i].addEventListener('change', function (e) {
            showResults(el, parseInt(e.target.value));
        });
    }
}
export function swapsCombinationsInit() {
    var fscEl = document.querySelector(JS_SELECTOR);
    if (fscEl) {
        startSwapsCombinations(fscEl);
        showResults(fscEl, 10);
    }
}
